<template>
  <v-container class="pa-2" fluid>
    <v-card class="card--group">
      <v-card-title
        class="pa-0 card--group relative"
        style="color: var(--v-white-base)"
      >
        <router-link
          :to="{ name: 'cctvList', query: { site_id: siteInfo.SITE_ID } }"
          class="nav-link"
        ></router-link>
        <router-link
          v-if="admin == true"
          class="font-weight-bold pl-3"
          style="text-decoration: none; color: white; font-size: 1.25rem;"
          :to="{
            path: '/master/siteRegister',
            query: { site_id: siteInfo.SITE_ID }
          }"
          >{{ siteInfo.SITE_NM }}</router-link
        >
        <span class="title bold" v-else>{{ siteInfo.SITE_NM }}</span>
        <div
          class="cctvClass"
          v-if="
            siteInfo.CCTV_STAT !== 'N' &&
              siteInfo.CCTV_STAT !== null &&
              siteInfo.CCTV_CNT > 0
          "
          v-on:click="goCctv(siteInfo.SITE_ID, siteInfo.CCTV_CNT)"
        >
          <v-icon style="color: white!important">mdi-cctv</v-icon>
        </div>
      </v-card-title>
      <v-tabs fixed-tabs show-arrows>
        <v-tab id="tab_all" @click="allInverterChange">전체</v-tab>
        <v-tab
          v-for="inverter in siteInfo.SITE_INVERTER"
          :key="inverter.STATION_ID + '_' + inverter.INVERTER_ID"
          :id="'tab_' + inverter.STATION_ID + '_' + inverter.INVERTER_ID"
          class="tabIconClass"
          @click="
            inverterChange(
              inverter.STATION_ID,
              inverter.INVERTER_ID,
              inverter.INVERTER_MODEL
            )
          "
        >
          <img
            v-if="inverter.STATUS === 'Run'"
            class="mr-1"
            src="@/assets/image/monitoring/icon_alert00.png"
            style="width: 16px;height: 16px;"
          />
          <img
            v-else-if="inverter.STATUS === 'Error'"
            class="mr-1"
            src="@/assets/image/monitoring/icon_alert01.png"
            style="width: 16px;height: 16px;"
          />
          <img
            v-else
            class="mr-1"
            src="@/assets/image/monitoring/icon_alert01.png"
            style="width: 16px;height: 16px;"
          />
          {{ inverter.INVERTER_NAME }}
        </v-tab>
      </v-tabs>
      <v-row
        v-model="tabs"
        class="ma-0 pa-0 card--group"
        style="height:48px;background-color: var(--v-subTab-base)!important;"
      >
        <v-col
          class="pa-0 d-flex justify-center align-center"
          v-for="(tab, idx) in tabList"
          :key="'tab_key_' + idx"
        >
          <span
            :id="'tab_' + tab.name"
            class="pa-0 pb-1 tab_txt"
            style="font-size:0.8rem;"
            v-bind:class="{ on: tab.isOn }"
            @click="changeTab(tab.name)"
            >{{ tab.label }}</span
          >
        </v-col>
      </v-row>
      <div class="site card--group">
        <section class="all_area">
          <component
            :is="comp"
            :tabIndex="tabs"
            :key="component_key"
            :SITE_ID="site_id"
            :ONOFFYN="this.siteInfo.ONOFFYN"
            :STATION_ID="station_id"
            :INVERTER_ID="inverter_id"
            :INVERTER_MODEL="inverter_model"
          ></component>
        </section>
      </div>

      <div
        id="brokenAccept_layer"
        class="layer_area check"
        style="z-index: 10;"
        v-show="false"
      >
        <div class="layer_content_area">
          <div class="top_area">
            <span class="layer_title">고장접수</span>
            <span class="close_btn">닫기버튼</span>
          </div>
          <div class="bottom_area">
            <div class="check_area">
              <span class="txt">고장 접수 하시겠습니까?</span>
            </div>
            <div class="check_btn">
              <router-link
                to="/mobile/receipt/receiptCustom"
                class="chk_btn bg_blue"
                >확인</router-link
              >
              <span class="chk_btn" @click="acceptLayerClose">취소</span>
            </div>
          </div>
        </div>
      </div>
    </v-card>
    <v-dialog
      fullscreen
      transition="dialog-bottom-transition"
      v-if="viewPopup"
      v-model="viewPopup"
      persistent
      max-width="600px"
    >
      <cctv-popup
        @closeDetailPop="viewPopup = false"
        :cctv-cnt="infoData.CCTV_CNT"
        :site-id="infoData.SITE_ID"
      ></cctv-popup>
    </v-dialog>
    <general-dialog v-model="modal" :title="popupTitle" :buttons="buttons">
      <v-card flat>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <p>마지막 비밀번호 변경후 180일이 지났습니다.</p>
                <p>비밀번호 변경을 권장드립니다. 변경하시겠습니까?</p>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </general-dialog>
  </v-container>
</template>

<script>
import { dateRenew } from '@/api/common/login'
import { getSiteInfo } from '@/api/pcs/siteWork'
import WorkState from '@/views/mobile/site/WorkState'
import WorkInverterState from '@/views/mobile/site/WorkInverterState'
import WorkRecord from '@/views/mobile/site/WorkRecord'
import BrokenRecord from '@/views/mobile/site/BrokenRecord'
import InverterCalendar from '@/components/mobile/InverterCalendar'
import localStore from '@/utils/localStore'
import GeneralDialog from '@/components/dialogSet/GeneralDialog'
import MpptInfo from '@/components/mobile/MpptInfo'
import cctvPopup from '@/views/pc/site/CctvPopup'
import store from '@/store'

// import '@/assets/js/swiper.js'

export default {
  components: {
    WorkState,
    WorkInverterState,
    WorkRecord,
    BrokenRecord,
    InverterCalendar,
    MpptInfo,
    cctvPopup,
    GeneralDialog
  },
  props: {
    SITE_ID: { type: String, default: '' },
    STATION_ID: { type: String, default: '' },
    INVERTER_ID: { type: String, default: '' },
    INVERTER_MODEL: { type: String, default: '' }
  },
  data() {
    return {
      site_id: this.SITE_ID,
      iconError: require('@/assets/image/monitoring/icon_alert02.png'),
      iconGreen: require('@/assets/image/monitoring/icon_alert00.png'),
      iconStrange: require('@/assets/image/monitoring/icon_alert01.png'),
      station_id: '',
      inverter_id: '',
      inverter_model: '',
      component_key: 1,
      modal: false,
      popupTitle: '비밀번호 변경',
      buttons: [
        {
          title: '변경',
          color: 'primary',
          class: 'white--text',
          handler: () => {
            this.closePopup({ ok: true })
          }
        },
        {
          title: '다음에 변경하기',
          text: true,
          handler: () => {
            this.closePopup({ ok: false })
          }
        }
      ],
      cctv_stat: 'N', // cctv_stat에 대해서 확인
      admin: false, // 관리자 구분 추가
      tabList: [
        {
          label: '운전현황',
          name: 'WorkState',
          isOn: true
        },
        {
          label: '운전/정지',
          name: 'WorkRecord',
          isOn: false
        },
        {
          label: '고장정보',
          name: 'BrokenRecord',
          isOn: false
        },
        {
          label: 'MPPT정보',
          name: 'MpptInfo',
          isOn: false
        },
        {
          label: '발전달력',
          name: 'InverterCalendar',
          isOn: false
        }
      ],
      subTab: [{ on: true }, { on: false }, { on: false }, { on: false }],
      main_area: true,
      siteInfo: { ONOFFYN: '' },
      comp: 'WorkState',
      swiper: null,
      searchType: '',
      searchWord: '',
      tabs: 0,
      viewPopup: false,
      infoData: {
        CCTV_CNT: 0,
        SITE_ID: ''
      }
    }
  },
  created() {
    this.site_id = this.$router.history.current.query.site_id
    if (this.$router.history.current.query.search_type !== undefined) {
      this.searchType = this.$router.history.current.query.search_type
    }
    if (this.$router.history.current.query.search_word !== undefined) {
      this.searchWord = this.$router.history.current.query.search_word
    }
    store.dispatch('SetHeaderUse', true)
    // 관리자 구분 추가 2019-10-07
    const grpAuth = this.$store.state.user.grp_auth || ''
    this.admin =
      grpAuth === 'usergroup001' ||
      grpAuth === 'usergroup002' ||
      grpAuth === 'usergroup004' ||
      grpAuth === 'usergroup008'
  },
  mounted() {
    window.scrollTo(0, 0)
    console.log('0')
    this.getDataSiteInfo()
    this.init_event()
    $('.search_btn').show()
    var pwChangeYN = localStore.get('pw_change')
    if (pwChangeYN === 'Y') {
      this.modal = true
    } else {
    }
  },
  updated() {
    this.update()
  },
  methods: {
    goCctv(SITE_ID, CCTV_CNT) {
      // const params = '?siteId=' + SITE_ID + '&cctvCnt=' + CCTV_CNT
      // this.$router.push('/cctvPopup' + params)
      this.infoData.SITE_ID = SITE_ID
      this.infoData.CCTV_CNT = Number(CCTV_CNT)
      this.viewPopup = true
    },
    init_event() {
      // let backCount = 0
      if (this.searchType !== '') {
        document.addEventListener(
          'backbutton',
          function(e) {
            this.$router.push(
              '/mobile/siteSearch?site_id=' +
                this.site_id +
                '&search_type=' +
                this.searchType +
                '&search_word=' +
                this.searchWord
            )
          }.bind(this)
        )
      }
    },
    getDataSiteInfo() {
      // 2. site_id 로 사이트정보를 조회한다 (사이트 주소 및 인버터등)
      let params = '?site_id=' + this.site_id
      getSiteInfo(params).then(res => {
        // this.cctv_cnt = res.CCTV_CNT
        this.cctv_stat = res.CCTV_STAT
        this.siteInfo = res
        this.inverterList = res.SITE_INVERTER

        // this.swiper = new Swiper('.swiper-container', {
        //   slidesPerView: 3,
        //   spaceBetween: 0,
        //   freeMode: true,
        //   pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true
        //   }
        // })
      })
    },
    update() {
      if (this.swiper) {
        this.swiper.update && this.swiper.update()
        this.swiper.navigation && this.swiper.navigation.update()
        this.swiper.pagination && this.swiper.pagination.render()
        this.swiper.pagination && this.swiper.pagination.update()
      }
    },
    allInverterChange() {
      this.station_id = ''
      this.inverter_id = ''
      this.inverter_model = ''
      $('.tab_txt_area .tab_txt').removeClass('on')
      $('#tab_all').addClass('on')
      this.component_key++
      this.changeTab('WorkState')
      $('.sub_tab_txt:eq(0)').addClass('on')
      // this.tabs = 0
      this.tabList[0].isOn = true
      window.scrollTo(0, 0)
    },
    inverterChange(stid, id, md) {
      this.station_id = stid
      this.inverter_id = id
      this.inverter_model = md
      $('.tab_txt_area .tab_txt').removeClass('on')
      $('#tab_' + stid + '_' + id).addClass('on')
      this.component_key++
      this.changeTab('WorkInverterState')

      $('.sub_tab_txt:eq(0)').addClass('on')
      // this.tabs = 0
      this.tabList[0].isOn = true
      window.scrollTo(0, 0)
    },
    changeTab(key) {
      for (let keyVal in this.tabList) {
        if (this.tabList[keyVal].name === key) {
          this.tabList[keyVal].isOn = true
        } else {
          this.tabList[keyVal].isOn = false
        }
      }
      if (key === 'BrokenAccept') {
        $('#brokenAccept_layer').show()
      } else {
        $('.sub_tab_txt').removeClass('on')
        this.comp = key
        if (key === 'WorkInverterState' || this.inverter_id !== '') {
          this.tabList[0].name = 'WorkInverterState'
        } else {
          this.tabList[0].name = 'WorkState'
        }

        $('#tab_' + key).addClass('on')
      }
    },
    acceptLayerClose() {
      $('#brokenAccept_layer').hide()
    },
    closePopup(result) {
      if (result.ok) {
        this.modal = false
        this.$router.replace('/mypage')
      } else {
        this.modal = false
        dateRenew(localStore.get('userId'))
        localStore.set('pw_change', '')
      }
    }
  }
}
</script>

<style lang="less" scoped>
// @import '../../../assets/swiper.less';
@import '../../../assets/mobile/site.less';
.tab_txt.on {
  color: #2196f3;
  border-bottom: 2px solid #2196f3;
}
.sub_tab_txt.on {
  border-bottom: 2px solid skyblue;
  padding-bottom: 7px !important;
  color: skyblue;
}
.tabIconClass {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap !important;
}
.relative {
  position: relative;
}
.cctvClass {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 20px;
  height: 100%;
  width: 32px;
  border-radius: 20px;
  background-color: var(--v-cctvIconBg-base);
}
</style>
